import ILocale from 'app/interfaces/ILocale';

import EnglandIcon from 'app/assets/flags/en.svg';
import RussiaIcon from 'app/assets/flags/ru.svg';
import ChinaIcon from 'app/assets/flags/zh.svg';

export const supportedLocaleCodes = ['en', 'ru', 'ch'];

export const locales: ILocale[] = [
  { code: 'en', title: 'English', icon: EnglandIcon },
  { code: 'ru', title: 'Русский', icon: RussiaIcon },
  { code: 'ch', title: '中文', icon: ChinaIcon },
];

export const DEFAULT_EMAIL_LENGTH = 160;

export const DEFAULT_PASSWORD_MIN_LENGTH = 6;
export const DEFAULT_PASSWORD_LENGTH = 4096;
